import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bf347e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "heading-text",
    id: "fast-links"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Швидкі посилання"),
    /*#__PURE__*/_createElementVNode("h3", null, "Rychlé odkazy")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fast-links" }, [
    /*#__PURE__*/_createElementVNode("ul", null, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.pardubickykraj.cz/pomoc-ukrajine",
          target: "_blank"
        }, [
          /*#__PURE__*/_createTextVNode(" Пардубіцький край "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" Pardubický kraj ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.nasiukrajinci.cz/ua/",
          target: "_blank"
        }, [
          /*#__PURE__*/_createTextVNode(" Наші українці "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" Naši Ukrajinci ")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("a", {
          href: "https://www.mvcr.cz/clanek/ua.aspx",
          target: "_blank"
        }, [
          /*#__PURE__*/_createTextVNode(" Міністерство внутрішніх "),
          /*#__PURE__*/_createElementVNode("br"),
          /*#__PURE__*/_createTextVNode(" Ministerstvo vnitra ")
        ])
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "heading-text",
    id: "informations"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "поточну інформацію"),
    /*#__PURE__*/_createElementVNode("h3", null, "Aktuální informace")
  ]),
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "1280",
    height: "720",
    src: "https://www.youtube.com/embed/8exy3m-Me7k",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  }),
  /*#__PURE__*/_createElementVNode("iframe", {
    width: "1280",
    height: "720",
    src: "https://www.youtube.com/embed/KlbFVWDeqSA",
    title: "YouTube video player",
    frameborder: "0",
    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
    allowfullscreen: ""
  }),
  /*#__PURE__*/_createElementVNode("div", {
    class: "heading-text",
    id: "documents"
  }, [
    /*#__PURE__*/_createElementVNode("h2", null, "Документи"),
    /*#__PURE__*/_createElementVNode("h3", null, "Dokumenty")
  ]),
  /*#__PURE__*/_createElementVNode("iframe", {
    src: "https://drive.google.com/embeddedfolderview?id=1btf6SRVUD91yDnsFKBoPuilOd50w70o5#grid",
    style: {"width":"100%","height":"400px","border":"0"}
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}